/**
 * Breaking Change Draft Notification Modal
 *
 * Displayed every time a Breaking Change request is saved in draft status.
 * User can choose to notify the BC Process Owner, save without notifying, or cancel.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './BreakingChangeDraftModal.css';

const BreakingChangeDraftModal = ({ onNotify, onJustSave, onCancel, loading, title, body }) => {
  return (
    <div className="bc-modal__overlay" role="dialog" aria-modal="true" aria-labelledby="bc-modal-title">
      <div className="bc-modal">
        <h2 id="bc-modal-title" className="bc-modal__title">
          {title}
        </h2>
        <p className="bc-modal__body">
          {body}
        </p>
        <div className="bc-modal__actions">
          <button
            className="bc-modal__button bc-modal__button--primary"
            onClick={onNotify}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Yes, Notify'}
          </button>
          <button
            className="bc-modal__button bc-modal__button--secondary"
            onClick={onJustSave}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'No, Just Save'}
          </button>
          <button
            className="bc-modal__button bc-modal__button--cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

BreakingChangeDraftModal.propTypes = {
  onNotify: PropTypes.func.isRequired,
  onJustSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string,
  body: PropTypes.string,
};

BreakingChangeDraftModal.defaultProps = {
  loading: false,
  title: 'Breaking Change — Internal Assessment Required',
  body: 'L3 review and approval of this request is required. PDO must complete an internal assessment PRIOR to engaging CIC. Do you want me to notify the Breaking Change Process Owner to begin this internal assessment?',
};

export default BreakingChangeDraftModal;
